/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackListItemViewModel } from "../types/FeedbackListItemViewModel.ts";

export const feedbackListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  title: z.string().nullish(),
  type: z.optional(z.number().int()),
  typeText: z.string().nullish(),
  answerCount: z.optional(z.number().int()),
}) as unknown as ToZod<FeedbackListItemViewModel>;
